<template>
  <div class="wrapper">
    <!-- <van-search
      v-model="value"
      shape="round"
      background="#F8F8F8"
      placeholder="搜索挂号科室"
      @input="handleQuery"
    >
      <template v-slot:left-icon>
        <img src="@/assets/payment/sousuo_icon.png" class="ss_icon">
      </template>
    </van-search> -->
    <lastpage></lastpage>
    <div class="cate_content" v-if="showIf">
      <ul class="list_index">
        <li v-for="(item,index) in oneList" :key="item.DeptID" @click="handleTab(index,item.DeptID)" :class="current == index?`list_xuan`:` `">
          <span>{{ item.DeptName }}</span>
          <!-- <svg :class="current == index?`selectTriangle`:`hide`" width="14" height="14" viewBox="-50 -50 300 300">
            <polygon class="triangle" stroke-linejoin="round" points="200 100 0 200 0 0"/>
          </svg> -->
        </li>
      </ul>
      <ul class="list_content">
        <li v-for="(item,index) in list" :key="item.DeptID" @click="choice(item)">
          <span>{{ item.DeptName }}</span>
          <span class="icon_cl"><van-icon name="arrow" /></span>
        </li>
      </ul>
    </div>
    <div class="query_content" v-if="!showIf">
      <van-empty description="该院区暂无可预约的科室" />
      {{ value }}
    </div>
  </div>
</template>

<script>
import { getRegDate, getRegLocation } from "@/request/api.js";
import lastpage from "@/components/lastpage/lastpage.vue";
import top from "@/components/Header/header";
export default {
  components: {
    top,
    lastpage
  },
  data(){
      return{
        current: 0,
        value: "",
        showIf: true,
        timeString: '',
        deptID: null,
        oneList: [],
        list: [],
        hspCode: sessionStorage.getItem("hspCode"),
        secondlist: [['放射科','CT室','伽玛刀治疗室'],['收费处','挂号处','核磁共振'],['咨询服务台','急诊科'],['注射室','采血室']]
      }
  },
  async created() {
    this.getTime();
    // this.list = this.secondlist[0]
  },
  activated() {
    this.getDepartment();
  },
  methods:{
    // 获取可挂号日期
    async getTime(){
      let map = {
        hspCode: this.hspCode,
        userId: "7148"
      }
      let res = await getRegDate(map);
      let ary = []
      if(res.data.obj.resultData.length != 0){
        res.data.obj.resultData.forEach(item => {
          ary.push(this.$moment(item).format("YYYY-MM-DD"))
        });
        this.timeString = ary.join(',');
        this.getDepartment();
        this.showIf = true;
      } else {
        this.showIf = false;
      }
    },
    // 科室查询
    async getDepartment(){
      if(!this.deptID){
        let map = {
          clinicDate: this.timeString,
          deptID: this.deptID,
          hspCode: this.hspCode,
          userId: "7148"
        }
        let res = await getRegLocation(map);
        this.oneList = res.data.obj.resultData;
        this.deptID = this.oneList[0].DeptID;
        this.getDepartment();
      } else {
        let map = {
          clinicDate: this.timeString,
          deptID: this.deptID,
          hspCode: this.hspCode,
          userId: "7148"
        }
        let res = await getRegLocation(map)
        this.list = res.data.obj.resultData
      }
    },
    handleTab(num,deptid){
      this.deptID = deptid
      this.current = num
      this.getDepartment()
    },
    // 搜索
    handleQuery(){
      // console.log(this.value)
      if(this.value){
        this.showIf = false
      }else{
        this.showIf = true
      }
    },
    choice(item){
      // console.log("小飞棍来喽");
      sessionStorage.setItem("DeptID",item.DeptID)
      this.$router.push("/ChooseDoctor")
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  background-color: #F8F8F8;
  /deep/ .van-search__content{
    background-color: #E4E4E4;
  }
  .triangle {
    fill: #1C96CB;
    stroke: #1C96CB;
    stroke-width: 100;
  }
  .ss_icon{
    position: relative;
    top: 2px;
    width: 11px;
    height: 13px;
  }
  .cate_content{
    // width: 375px;
    flex-grow: 1;
    display: flex;
    flex-flow: row nowrap;
    position: relative;
    overflow: hidden;
    .list_index{
      display: flex;
      flex-flow: column nowrap;
      overflow-y: scroll;
      width: 118px;
      height: 100%;
      background-color: #F8F8F8;
      border-right: 1px solid rgb(207, 217, 255);
      >li{
        // border-bottom: 1px solid rgb(207, 217, 255);
        position: relative;
        // height: 45px;
        padding: 20px 0px;
        color: black;
        font-size: 15px;
        font-weight: 400;
        text-align: center;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        >span{
          // flex: 1;
          width: 100%;
          padding: 0px 14px 0px 12px;
        }
        .selectTriangle{
          position: absolute;
          right: 0px;
          // margin: 1px 6px 0px 0px;
        }
        .hide{
          display: none;
        }
      }
      .list_xuan{
        background: #fff;
        color: #1C96CB;
        font-weight: 700;
      }
    }
    .list_content{
      flex: 1;
      position: relative;
      flex-grow: 1;
      height: 100%;
      background: #fff;
      display: flex;
      flex-flow: column nowrap;
      overflow-y: scroll;
      // margin-right: 10px;
      >li{
        position: relative;
        // height: 45px;
        // line-height: 45px;
        display: flex;
        box-sizing: border-box;
        padding: 12px 30px;
        font-size: 16px;
        font-weight: 700;
        border-bottom: 1px solid rgb(233, 233, 233);
        align-items: center;
        >span:nth-child(1){
          flex: 1;
        }
        .icon_cl{
          font-size: 16px;
        }
      }
    }
  }
  .query_content{
    margin-top: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/DepartmentSelection.vue